import React, { useEffect, useState } from 'react';
import { Card, Container, Row, Col, Button, Form, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ImArrowRight2, ImSearch } from 'react-icons/im';
import { blogApi } from '../../apiService/blogApis';
import axios from 'axios';
import API_CONFIG from '../../config/api';
import { trackGAEvent, GA_EVENTS } from '../../utils/googleAnalytics';

const Blog = ({ searchQuery, setSearchQuery, onSearchChange }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState('All');
  // const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [pagination, setPagination] = useState({});
  const postsPerPage = 6;

  const [categories, setCategories] = useState([]);

  const fetchBlogs = async () => {
    try {
      setLoading(true);
      const params = {
        page: currentPage,
        limit: postsPerPage,
        status: 'published',
        ...(selectedCategory !== 'All' && { category: selectedCategory }),
        ...(debouncedSearch && { query: debouncedSearch })
      };
      const response = await blogApi.getBlogs(params);
      setBlogs(response.data || []);
      setPagination(response.pagination || {});
    } catch (error) {
      console.error('Error fetching blogs:', error);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  useEffect(() => {
    fetchBlogs();
  }, [currentPage, selectedCategory, debouncedSearch]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setCurrentPage(1);
    trackGAEvent(GA_EVENTS.BLOG_CATEGORY_FILTER, 'Filter', `Category: ${category}`);
  };

  const handleSearchChange = (e) => {
    onSearchChange(e.target.value);
    if (currentPage !== 1) setCurrentPage(1);
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_CONFIG?.BASE_URL}/api/categories?limit=20`);
      if (response?.data?.data?.length) {
        setCategories(response?.data?.data);
      }
    } catch (error) {
    }
  };

  const totalPages = pagination.totalPages || 0;

  const calculateReadingTime = (content) => {
    if (!content) return 0;
    const text = content.replace(/<[^>]*>/g, '');
    const words = text.trim().split(/\s+/).length;
    return Math.ceil(words / 225);
  };

  return (
    <div className="blog-page">
      {/* Fixed Search and Filter */}
      <div
        className="sticky-top py-2 bg-white shadow-sm"
        style={{
          top: '90px',
          zIndex: 1020,
        }}
      >
        <Container>
          {/* Search Bar */}
          <Row className="mb-3">
            {/* <Col md={8} lg={6} className="mx-auto">
              <div className="position-relative">
                <Form.Control
                  type="text"
                  placeholder="Search blogs..."
                  value={searchQuery}
                  onChange={handleSearchChange}
                  style={{
                    paddingLeft: '45px',
                    paddingRight: '15px',
                    height: '48px',
                    borderRadius: '24px',
                    border: '2px solid #e9ecef',
                    fontSize: '15px',
                    transition: 'all 0.3s ease'
                  }}
                  className="shadow-sm"
                  onFocus={(e) => {
                    e.target.style.borderColor = '#F37016';
                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(243, 112, 22, 0.15)';
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#e9ecef';
                    e.target.style.boxShadow = '';
                  }}
                />
                <ImSearch
                  style={{
                    position: 'absolute',
                    left: '18px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#6c757d',
                    fontSize: '18px'
                  }}
                />
                {searchQuery && (
                  <button
                    onClick={() => setSearchQuery('')}
                    style={{
                      position: 'absolute',
                      right: '15px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      color: '#6c757d',
                      cursor: 'pointer',
                      fontSize: '20px',
                      padding: '0',
                      width: '24px',
                      height: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    ×
                  </button>
                )}
              </div>
            </Col> */}
          </Row>

          {/* Categories */}
          {categories.length > 0 && (
            <div
              className="d-flex align-items-center gap-2 pb-2"
              style={{
                overflowX: 'auto',              // Enables horizontal scrolling
                overflowY: 'hidden',            // Hides vertical scrollbar
                scrollbarWidth: 'thin',         // For Firefox — valid values: 'auto', 'thin', 'none'
                scrollbarColor: '#4441415e #f8f9fa', // For Firefox — thumb color then track color
                msOverflowStyle: 'auto',        // For Internet Explorer / Edge (legacy)
                WebkitOverflowScrolling: 'touch' // Smooth scrolling on iOS
              }}
            >
              <Button
                onClick={() => handleCategoryChange('All')}
                variant="outline-secondary"
                size="sm"
                style={{
                  background: selectedCategory === 'All'
                    ? 'linear-gradient(to right, #F37016 0%, #B1510F 100%)'
                    : 'white',
                  color: selectedCategory === 'All' ? 'white' : '#495057',
                  border: selectedCategory === 'All' ? 'none' : '1px solid #dee2e6',
                  borderRadius: '20px',
                  padding: '8px 20px',
                  fontWeight: '500',
                  fontSize: '14px',
                  whiteSpace: 'nowrap',
                  transition: 'all 0.3s ease',
                  boxShadow: selectedCategory === 'All' ? '0 2px 8px rgba(243, 112, 22, 0.3)' : 'none'
                }}
                onMouseEnter={(e) => {
                  if (selectedCategory !== 'All') {
                    e.target.style.borderColor = '#F37016';
                    e.target.style.color = '#F37016';
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedCategory !== 'All') {
                    e.target.style.borderColor = '#dee2e6';
                    e.target.style.color = '#495057';
                  }
                }}
              >
                All Blogs
              </Button>
              {categories?.map((category) => (
                <Button
                  key={category?._id}
                  onClick={() => handleCategoryChange(category?.name)}
                  variant="outline-secondary"
                  size="sm"
                  style={{
                    background: selectedCategory === category?.name
                      ? 'linear-gradient(to right, #F37016 0%, #B1510F 100%)'
                      : 'white',
                    color: selectedCategory === category?.name ? 'white' : '#495057',
                    border: selectedCategory === category?.name ? 'none' : '1px solid #dee2e6',
                    borderRadius: '20px',
                    padding: '8px 20px',
                    fontWeight: '500',
                    fontSize: '14px',
                    whiteSpace: 'nowrap',
                    transition: 'all 0.3s ease',
                    boxShadow: selectedCategory === category?.name ? '0 2px 8px rgba(243, 112, 22, 0.3)' : 'none'
                  }}
                  onMouseEnter={(e) => {
                    if (selectedCategory !== category?.name) {
                      e.target.style.borderColor = '#F37016';
                      e.target.style.color = '#F37016';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedCategory !== category?.name) {
                      e.target.style.borderColor = '#dee2e6';
                      e.target.style.color = '#495057';
                    }
                  }}
                >
                  {category?.name}
                </Button>
              ))}
            </div>
          )}
        </Container>
      </div>

      {/* Blog Content */}
      <Container style={{ paddingTop: '140px' }} className="pb-5">
        {loading ? (
          <Row className="mt-4">
            <Col className="text-center py-5">
              <Spinner style={{ color: '#F37016' }} />
            </Col>
          </Row>
        ) : blogs.length > 0 ? (
          <>
            {/* Featured Blog Section */}
            {blogs.filter(post => post.featured).map(featuredPost => (
              <Row className="mb-5" key={featuredPost._id}>
                <Col>
                  <Card className="border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden', background: 'linear-gradient(135deg, #FCE7D0 0%, #F5D5B8 100%)' }}>
                    <Row className="g-0">
                      <Col md={6}>
                        <div style={{ height: '350px', overflow: 'hidden' }}>
                          <Card.Img
                            src={featuredPost?.coverImage?.url || require('../../assets/flatlayImg.webp')}
                            style={{
                              height: '100%',
                              width: '100%',
                              objectFit: 'cover'
                            }}
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <Card.Body className="p-4 h-100 d-flex flex-column">
                          <div className="d-flex align-items-center mb-0">
                            <span className="badge me-3" style={{ background: '#F37016', color: 'white', borderRadius: '12px', fontSize: '12px' }}>FEATURED</span>
                            <span className="badge" style={{ background: 'rgba(42, 48, 64, 0.1)', color: '#2A3040', borderRadius: '12px', fontSize: '12px' }}>
                              {featuredPost.category}
                            </span>
                          </div>
                          <h2 className="my-1" style={{ fontSize: '28px', fontWeight: '700', color: '#2A3040', lineHeight: '1.3' }}>
                            {featuredPost.title}
                          </h2>
                          <p className="text-muted my-1 flex-grow-1" style={{ fontSize: '16px', lineHeight: '1.6' }}>
                            {featuredPost.excerpt?.length > 200 ? featuredPost.excerpt.slice(0, 199) + '...' : featuredPost.excerpt}
                          </p>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="text-muted">
                              <small>{new Date(featuredPost.createdAt).toLocaleDateString()}</small>
                              <span className="mx-2">•</span>
                              <small>{calculateReadingTime(featuredPost?.content)} min read</small>
                            </div>
                            <Link
                              to={`/blog/${featuredPost.slug || featuredPost._id}`}
                              className="text-decoration-none"
                              onClick={() => trackGAEvent(GA_EVENTS.BLOG_READ_ARTICLE, 'Blog', `Featured: ${featuredPost.title}`)}
                            >
                              <button className="btn" style={{ background: '#F37016', color: 'white', borderRadius: '12px', padding: '10px 20px', border: 'none', fontWeight: '500' }}>
                                Read Article
                              </button>
                            </Link>
                          </div>
                        </Card.Body>
                      </Col>
                    </Row>
                  </Card>
                </Col>
              </Row>
            ))}

            {/* Regular Blog Posts Grid */}
            <Row className="mt-4">
              {blogs.filter(post => !post.featured).map(post => (
                <Col lg={4} md={6} className="mb-4" key={post._id}>
                  <Link
                    to={`/blog/${post.slug || post._id}`}
                    className="text-decoration-none"
                    style={{ color: 'inherit' }} // Ensures no blue/purple text color
                    onClick={() => trackGAEvent(GA_EVENTS.BLOG_READ_MORE, 'Blog', `Post: ${post.title}`)}
                  >
                    <Card className="h-100 shadow-sm border-0" style={{ borderRadius: '20px', overflow: 'hidden', cursor: 'pointer' }}>
                      <div style={{ height: '200px', overflow: 'hidden' }}>
                        <Card.Img
                          variant="top"
                          src={post?.coverImage?.url || require('../../assets/flatlayImg.webp')}
                          style={{
                            height: '100%',
                            objectFit: 'cover',
                            transition: 'transform 0.3s ease'
                          }}
                          className="blog-card-img"
                        />
                      </div>
                      <Card.Body className="d-flex flex-column px-4">
                        <div className="d-flex justify-content-between align-items-center mb-2 py-1">
                          <span
                            className="badge"
                            style={{
                              background: "linear-gradient(to right, #F37016 0%, #B1510F 100%)",
                              color: "white",
                              borderRadius: "12px",
                              fontSize: "12px"
                            }}
                          >
                            {post.category}
                          </span>
                        </div>
                        <Card.Title className="mb-0" style={{ fontSize: '16px', fontWeight: '600', color: '#2A3040' }}>
                          {post?.title}
                        </Card.Title>
                        <Card.Text className="text-muted my-2 flex-grow-1" style={{ fontSize: '14px', lineHeight: '1.4' }}>
                          {post?.excerpt?.length > 150 ? post?.excerpt?.slice(0, 149) + '...' : post?.excerpt}
                        </Card.Text>
                        <div className="d-flex justify-content-between align-items-center mt-auto">
                          <small className="text-muted">{new Date(post.createdAt || post.date).toLocaleDateString()}</small>
                          <div className="d-flex align-items-center" style={{ color: '#F37016' }}>
                            <span className="me-2" style={{ fontSize: '14px', fontWeight: '500' }}>Read More</span>
                            <ImArrowRight2 size={14} />
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Link>
                </Col>

              ))}
            </Row>
          </>
        ) : (
          <Row className="mt-4">
            <Col className="text-center py-5">
              <div className="mb-4">
                <h4 style={{ color: '#2A3040' }}>No blogs found</h4>
                <p className="text-muted">
                  {searchQuery || selectedCategory !== 'All'
                    ? 'Try adjusting your search or filter criteria.'
                    : 'There are no published blogs available at the moment.'}
                </p>
              </div>
            </Col>
          </Row>
        )}

        {/* Pagination */}
        {totalPages > 1 && (
          <Row className="mt-4">
            <Col className="d-flex justify-content-center">
              <div className="d-flex gap-2">
                {Array.from({ length: totalPages }, (_, i) => (
                  <Button
                    key={i + 1}
                    variant={currentPage === i + 1 ? "warning" : "outline-secondary"}
                    size="sm"
                    onClick={() => {
                      setCurrentPage(i + 1);
                      trackGAEvent(GA_EVENTS.BLOG_PAGINATION, 'Navigation', `Page ${i + 1}`);
                    }}
                    style={{
                      background: currentPage === i + 1
                        ? "linear-gradient(to right, #F37016 0%, #B1510F 100%)"
                        : "transparent",
                      border: "1px solid #dee2e6",
                      color: currentPage === i + 1 ? "white" : "#6c757d",
                      borderRadius: "8px",
                      width: "40px",
                      height: "40px"
                    }}
                  >
                    {i + 1}
                  </Button>
                ))}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default Blog;
